<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { useFormModel } from "@/hooks";
const { setFormModel } = useFormModel();
defineExpose({ setFormModel });
</script>
<template>
  <nut-radio-group class="mp-radio-group" v-bind="$attrs">
    <slot />
  </nut-radio-group>
</template>
